import {
  CartAddEvent
} from '@theme/events';


class CFCFeaturedCart {
  constructor() {
    this.busyButtons = new WeakSet();

    document.addEventListener(
      'cfc:add-variant',
      this.onAddVariant
    );

    console.log('[CFC] Cart bridge initialized');
  }


  onAddVariant = async (event) => {
    const detail = event.detail || {};
    const variantId = String(detail.variantId || '');
    const button = detail.button || null;

    if (!variantId || !button) return;

    if (this.busyButtons.has(button)) return;

    this.busyButtons.add(button);

    const title =
      button.querySelector('.cfc__variant-title');

    const originalTitle =
      title ? title.textContent : '';

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');


    try {
      /* ============================
         ADD SELECTED VARIANT
      ============================ */

      const addResponse = await fetch(
        '/cart/add.js',
        {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },

          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1
              }
            ]
          })
        }
      );


      const addData =
        await addResponse
          .json()
          .catch(() => ({}));


      if (!addResponse.ok) {
        throw new Error(
          addData.description ||
          addData.message ||
          'Could not add product.'
        );
      }


      /* ============================
         GET FRESH COMPLETE CART
      ============================ */

      const cartResponse = await fetch(
        '/cart.js',
        {
          cache: 'no-store',

          headers: {
            Accept: 'application/json'
          }
        }
      );


      if (!cartResponse.ok) {
        throw new Error(
          'Could not refresh cart.'
        );
      }


      const cart =
        await cartResponse.json();


      /* ============================
         HORIZON NATIVE CART EVENT

         Same approach as your
         working 2ml sample script.
      ============================ */

      document.dispatchEvent(
        new CartAddEvent(
          cart,
          'custom-featured-collection',
          {
            source:
              'custom-featured-collection',

            didError: false,

            variantId:
              String(variantId),

            itemCount:
              cart.item_count,

            sections: {}
          }
        )
      );


      console.log(
        '[CFC] Added + cart notified:',
        variantId,
        cart.item_count
      );


      /* ============================
         SUCCESS UI
      ============================ */

      button.classList.remove('is-loading');
      button.classList.add('is-added');
      button.removeAttribute('aria-busy');


      if (title) {
        title.textContent = 'ADDED';
      }


      setTimeout(() => {
        button.classList.remove('is-added');

        if (title) {
          title.textContent = originalTitle;
        }
      }, 1200);


    } catch (error) {
      console.error(
        '[CFC] Add to cart error:',
        error
      );

      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');

      const product =
        button.closest('[data-cfc-product]');

      const message =
        product?.querySelector(
          '[data-cfc-message]'
        );

      if (message) {
        message.textContent =
          error.message ||
          'Unable to add product.';

        message.classList.add(
          'is-visible',
          'is-error'
        );

        setTimeout(() => {
          message.classList.remove(
            'is-visible',
            'is-error'
          );

          message.textContent = '';
        }, 3000);
      }

    } finally {
      this.busyButtons.delete(button);
    }
  };
}


if (!window.__cfcFeaturedCartInitialized) {
  window.__cfcFeaturedCartInitialized = true;

  new CFCFeaturedCart();
}